export default __webpack_public_path__ + "static/media/svg-1.fd6199ea.svg";